/*
 * @Author: your name
 * @Date: 2022-02-26 13:43:24
 * @LastEditTime: 2024-09-19 09:58:47
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \kares_pad\src\i18n\language\index.js
 */
import custom_en from './en-US'; // 英文
import custom_zh from './zh-CN'; // 中文
import custom_vi from './vi'; // 越南语
import custom_ru from './ru'; // 俄罗斯语

// import n_en from './n_en.js'; // 英文
// import n_zh from './n_zh.js'; // 中文
// import n_vi from './n_vi.js'; // 越南语
// import n_ru from './n_ru.js'; // 俄罗斯语

import el_en from 'element-ui/lib/locale/lang/en';
import el_zh from 'element-ui/lib/locale/lang/zh-CN';
import el_vi from 'element-ui/lib/locale/lang/vi';
import el_ru from 'element-ui/lib/locale/lang/ru-RU';

import languages from './languages/index.js';

import newMessages from './newMessages.js';

const { zh, en, vi, ru } = languages;

const { zh: n_zh, en: n_en, vi: n_vi, ru: n_ru } = newMessages;

export default {
  en: {
    ...custom_en,
    ...el_en,
    ...n_en,
    ...en
  },
  zh: {
    ...custom_zh,
    ...el_zh,
    ...n_zh,
    ...zh
  },
  vi: {
    ...custom_vi,
    ...el_vi,
    ...n_vi,
    ...vi
  },
  ru: {
    ...custom_ru,
    ...el_ru,
    ...n_ru,
    ...ru
  }
}